import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './list.module.css';
import { Dialog, Popover } from '@mui/material';
import { ChevronDown, ChevronUp, Code, Edit, Trash2, User, X } from 'react-feather';
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useAuth0 } from '@auth0/auth0-react';

const formatPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length !== 10) return phone;

  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}

const isWithin30Days = (createdAt) => {
  if (!createdAt) return false;
  const createdDate = new Date(createdAt);
  const today = new Date();
  const diffInDays = (today - createdDate) / (1000 * 60 * 60 * 24);
  return diffInDays <= 30;
}

const VehicleList = ({ allData, filterData, setEditModalOpen, setEditData, setSelectedId, setDeleteVehicleModalOpen }) => {
  const redirect = useHistory();
  const { user, isAuthenticated } = useAuth0();
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [carImage, setCarImage] = useState("");
  const [openPop, setOpenPop] = useState(false);

  const handleOpen = () => {
    setOpenPop(true);
  }
  const handleClose = () => {
    setOpenPop(false);
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
    setCarImage("");
  };
  const open = Boolean(anchorEl);

  const toggleRow = (rowId) => {
    setExpandedRowId(prev => prev === rowId ? null : rowId);
  };

  const tenantVehicles = allData.filter(v => v.is_guest === 0);
  const guestVehicles = allData.filter(v => v.is_guest === 1);

  const rowsData = tenantVehicles.map((tenant) => {
    // Find all tenant vehicles for same lease
    const sameTenantVehicles = tenantVehicles.filter(
      t => t.tenant_id === tenant.tenant_id
    );

    // Primary applicant = lowest tenant_info_id
    const primaryApplicant = sameTenantVehicles.reduce((prev, curr) =>
      curr.tenant_info_id < prev.tenant_info_id ? curr : prev
    );

    const guest =
      primaryApplicant.id === tenant.id
        ? guestVehicles.find(g => g.tenant_id === tenant.tenant_id)
        : null;

    return {
      id: tenant.id,
      initials: tenant.tenant_initial,
      name: tenant.tenant_name,
      license: tenant.license,
      make: tenant.make,
      model: tenant.model,
      color: tenant.color,
      property_id: tenant.property_id,
      property: tenant.property_name,
      unit: tenant.apt_no,
      tenant_image: tenant.tenant_image,
      tenant_id: tenant.tenant_id,
      tenant_info_id: tenant.tenant_info_id,
      apt_id: tenant.apt_id,
      isNew: isWithin30Days(tenant.created_at),
      image_path: tenant.image_path,
      image_thumbail_path: tenant.image_thumbail_path,

      guest: guest ? {
        name: `${guest.guest_fname} ${guest.guest_lname}`,
        phone: formatPhone(guest.guest_phone),
        license: guest.license,
        make: guest.make,
        model: guest.model,
        color: guest.color,
        image_path: guest.image_path,
        image_thumbail_path: guest.image_thumbail_path,
        tenant_id: guest.tenant_id,
        tenant_info_id: guest.tenant_info_id,
        apt_id: guest.apt_id,
        property_id: guest.property_id,
        guest_fname: guest.guest_fname,
        guest_lname: guest.guest_lname,
        guest_phone: guest.guest_phone,
        id: guest.id,
        is_guest: 1
      } : null,
    };
  });

  const changeSortOrder = (type) => {
    if (type === sortItem) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
    setSortItem(type);
  }

  const goToDetails = (item) => {
    if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1) {
      setEditModalOpen(true);
      setEditData(item);
    } else {
      return false;
    }
  }


  return (
    <div className={`${styles.IncomeListUnderSec}`}>

      <div className={`${styles.ListCardDivSec}`}>
        {rowsData.map((item) => {
          const showBadge = isWithin30Days(item.created_at);
          return (<div className={`${styles.CardDivList}`}>
            <div className={`${styles.FirstSec} ${styles.ProfileImg}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/people/tenants/details/" + item.tenant_id); }}>
              {item?.tenant_id ? (<>
                {item?.tenant_image !== "" ? (<img src={item?.tenant_image} alt="" />) : (<div className={`${styles.ProNameIMG}`}>
                  <p>{item?.tenant_initial}</p>
                </div>)}
              </>) : (<div className={`${styles.ProNameIMG}`}>
                <User />
              </div>)}
              <div>
                <p className={`${styles.Name} ${styles.Hover}`}>{item?.tenant_id ? <>{item?.name}</> : "-"}</p>
                <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item.property} - {item.unit}</p>
              </div>
            </div>
            <div className={`${styles.SecondSec}`}>
              <p className={`${styles.Name}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setCarImage(item?.image_path); handleOpen(); }}>
                License: <span>{item.license}</span>
                {item?.image_thumbail_path !== "" ? <img src={item?.image_thumbail_path} alt="" className={`${styles.CarImgForSmall}`} /> : <img src={"/static/img/no-car.png"} alt="" className={`${styles.CarImgForSmall}`} />}
              </p>
              <p className={`${styles.Name}`}>
                Make: <span>{item.make}</span> Model: <span>{item.model}</span> Color: <span>{item.color}</span>
              </p>
            </div>
            <div className={`${styles.ThirdSec}`}>
              {showBadge && (<span className={styles.NewBadge}>New</span>)}
            </div>
          </div>);
        })}
      </div>

      <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={`${styles.TableHead}`} style={{ width: 300 }} onClick={(e) => changeSortOrder("tenant_name")}>
                Tenant
                {sortItem === "tenant_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "tenant_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "tenant_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 200 }} onClick={(e) => changeSortOrder("license")}>
                License
                {sortItem === "license" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "license" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "license" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("make")}>
                Make
                {sortItem === "make" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "make" && sortOrder === "desc" && <ChevronUp />}
                {sortItem !== "make" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("model")}>
                Model
                {sortItem === "model" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "model" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "model" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 200 }} onClick={(e) => changeSortOrder("color")}>
                Color
                {sortItem === "color" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "color" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "color" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 200 }} onClick={(e) => changeSortOrder("property_name")}>
                Property
                {sortItem === "property_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "property_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "property_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("apt_no")}>
                Unit
                {sortItem === "apt_no" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "apt_no" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "apt_no" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Guest</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsData.sort((a, b) => {
              if (sortItem === "tenant_name") {
                if (sortOrder === "desc") {
                  return a?.name?.localeCompare(b?.name);
                } else {
                  return b?.name?.localeCompare(a?.name);
                }
              } else if (sortItem === "license") {
                if (sortOrder === "desc") {
                  return a?.license?.localeCompare(b?.license);
                } else {
                  return b?.license?.localeCompare(a?.license);
                }
              } else if (sortItem === "make") {
                if (sortOrder === "desc") {
                  return a?.make?.localeCompare(b?.make);
                } else {
                  return b?.make?.localeCompare(a?.make);
                }
              } else if (sortItem === "model") {
                if (sortOrder === "desc") {
                  return a?.model?.localeCompare(b?.model);
                } else {
                  return b?.model?.localeCompare(a?.model);
                }
              } else if (sortItem === "color") {
                if (sortOrder === "desc") {
                  return a?.color?.localeCompare(b?.color);
                } else {
                  return b?.color?.localeCompare(a?.color);
                }
              } else if (sortItem === "property_name") {
                if (sortOrder === "desc") {
                  return a.property_name < b.property_name ? 1 : -1;
                } else {
                  return a.property_name > b.property_name ? 1 : -1;
                }
              } else if (sortItem === "apt_no") {
                if (sortOrder === "desc") {
                  return a?.unit?.localeCompare(b?.unit);
                } else {
                  return b?.unit?.localeCompare(a?.unit);
                }
              } else {
                return (b?.id ?? 0) - (a?.id ?? 0);
              }
            }).map((row, index) => {
              const rowClass = index % 2 === 0 ? styles.MainRowOdd : styles.MainRowEven;
              const isExpanded = expandedRowId === row.id;

              return (<>
                <TableRow className={rowClass} onClick={(e) => goToDetails(row)}>
                  <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}>
                    {row?.tenant_image !== "" ? <img src={row?.tenant_image} alt="" /> : <div className={styles.AvatarCircle} style={{ backgroundColor: '#E0F2FE', color: '#0284C7' }}>
                      {row.initials}
                    </div>}
                    <div style={{ display: 'inline-flex', gap: '4px' }}>
                      <span className={styles.TenantNameText} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/people/tenants/details/" + row.tenant_id); }}>{row.name}</span>
                      {row.isNew && <p className={styles.NewBadgeSmall}>New</p>}
                    </div>
                  </TableCell>
                  <TableCell className={styles.TableBodyText}>
                    <div className={`${styles.DisplayFlex}`}>
                      {row.license}
                      {row?.image_thumbail_path !== "" ? <div className={`${styles.CarSec}`} onMouseEnter={(e) => { setCarImage(row?.image_path); handlePopoverOpen(e); }} onMouseLeave={handlePopoverClose}>
                        <img src={row?.image_thumbail_path} alt="" />
                      </div> :
                        <div className={`${styles.NoCarSec}`}>
                          <img src={"/static/img/no-car.png"} alt="" />
                        </div>}
                    </div>
                  </TableCell>
                  <TableCell className={styles.TableBodyText}>{row.make}</TableCell>
                  <TableCell className={styles.TableBodyText}>{row.model}</TableCell>
                  <TableCell className={styles.TableBodyText}>{row.color}</TableCell>
                  <TableCell className={`${styles.TableBodyText} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + row?.property_id); }}>
                    <span className={styles.PropertyText}>{row.property}</span>
                  </TableCell>
                  <TableCell className={styles.TableBodyText}>{row.unit}</TableCell>
                  <TableCell
                    className={styles.TableBodyText}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (row.guest)
                        toggleRow(row.id);
                    }}
                  >
                    {row.guest ? (
                      <div className={styles.GuestBadgeContainer}>
                        <span className={styles.GreenDot}></span>
                        <span className={styles.GuestBadgeText}>Guest</span>
                        {isExpanded ? <ChevronUp size={16} className={styles.ChevronIcon} /> : <ChevronDown size={16} className={styles.ChevronIcon} />}
                      </div>
                    ) : (
                      <div className={styles.NoneBadge}>
                        <span className={styles.GrayDot}></span>
                        <span>None</span>
                      </div>
                    )}
                  </TableCell>
                </TableRow>
                {isExpanded && row.guest && (
                  <TableRow className={styles.ExpandedRow}>
                    <TableCell colSpan={8} className={styles.ExpandedCell}>
                      <div className={styles.GuestDetailsContainer}>
                        <div className={styles.GuestDetailsHeader}>
                          <User size={14} className={styles.GuestIcon} />
                          <span>Guest Details</span>
                        </div>
                        <div className={styles.GuestDetailsCard}>
                          <div className={styles.GuestDetailsGrid}>
                            <div className={styles.GuestDetailsColImage}>
                              {row?.guest?.image_thumbail_path !== "" ? <div className={`${styles.CarSec}`} onMouseEnter={(e) => { setCarImage(row?.guest?.image_path); handlePopoverOpen(e); }} onMouseLeave={handlePopoverClose}>
                                <img src={row?.guest?.image_thumbail_path} alt="" />
                              </div> :
                                <div className={`${styles.NoCarSec}`}>
                                  <img src={"/static/img/no-car.png"} alt="" />
                                </div>}
                            </div>
                            <div className={styles.GuestDetailsCol}>
                              <div className={styles.GuestLabel}>Name</div>
                              <div className={styles.GuestValue}>{row.guest.name}</div>
                            </div>
                            <div className={styles.GuestDetailsCol}>
                              <div className={styles.GuestLabel}>Phone</div>
                              <div className={styles.GuestValue}>{row.guest.phone}</div>
                            </div>
                            <div className={styles.GuestDetailsCol}>
                              <div className={styles.GuestLabel}>License plate</div>
                              <div className={styles.GuestValue}>
                                <span className={styles.LicenseBadge}>{row.guest.license}</span>
                              </div>
                            </div>
                            <div className={styles.GuestDetailsCol}>
                              <div className={styles.GuestLabel}>Make</div>
                              <div className={styles.GuestValue}>{row.guest.make}</div>
                            </div>
                            <div className={styles.GuestDetailsCol}>
                              <div className={styles.GuestLabel}>Model</div>
                              <div className={styles.GuestValue}>{row.guest.model}</div>
                            </div>
                            <div className={styles.GuestDetailsCol}>
                              <div className={styles.GuestLabel}>Color</div>
                              <div className={styles.GuestValue}>{row.guest.color}</div>
                            </div>
                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <div className={`${styles.GuestDetailsCol} ${styles.ActionBUSec}`}>
                              <button className={`${styles.GuestActionBU}`} onClick={(e) => goToDetails(row.guest)}><Edit /></button>
                              <button className={`${styles.GuestActionBU} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(row?.guest?.id); }}><Trash2 /></button>
                            </div>}
                          </div>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </>);
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {rowsData.length === 0 && (<div className={`${styles.NoDataMain}`}>
        <div className={`${styles.NoDataIMG}`}>
          <img src="/static/img/no-car.png" alt="No Data" />
        </div>
        <p className={`${styles.NoDataText}`}>Unfortunately!</p>
        <p className={`${styles.NoDataTextSub}`}>
          we couldn't find any vehicle at this time.
        </p>
      </div>)}

      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: "none" }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className={`${styles.PopupImgSec}`}>
          <img src={carImage} alt="" />
        </div>
      </Popover>

      <Dialog
        open={openPop}
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleClose()
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={`${styles.PopupImgSec}`}>
          <img src={carImage} alt="" />
          <button onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose()
          }}><X /></button>
        </div>
      </Dialog>

    </div>
  );
}

export default VehicleList;